





















































import "@/assets/css/split.css";
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import Moment from "moment-timezone";
import echarts from "echarts";
import XLSX from "@/lib/Common/excel";
import SearchTree from "@/lib/Common/searchtree";

class PageUserRequest extends PageRequest {
  keyword: string;
  areaId: number;
  startTime: string;
  endTime: string;
  operaType: number;
  meterId: string;
  isTotal: number;
}

@Component({
  components: {},
})
export default class HourUseList extends AbpBase {
  pagerequest: PageUserRequest = new PageUserRequest();
  areaTree: any[] = [];
  areaTreeList: any[] = [];
  searchName: string = "";
  columns: any[] = [];
  itemId: string = "0";
  height: number = 300;
  usebar: any; //图表
  useCount: number = 0;
  loadsear: boolean = false;
  splitnum: number = 0.15;
  get list() {
    return this.$store.state.hoursuserecord.list;
  }
  get loading() {
    return this.$store.state.hoursuserecord.loading;
  }
  pageChange(page: number) {
    this.$store.commit("hoursuserecord/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("hoursuserecord/setPageSize", pagesize);
    this.getpage();
  }
  changeSort(key) {
    this.pagerequest.sorting = key.key + " " + key.order;
    this.getpage();
  }
  getItemId() {
    let item = (this.$refs.tree as any).getSelectedNodes();
    if (item.length > 0) {
      if (item[0].id.length < 10) {
        this.pagerequest.areaId = item[0].id;
        this.pagerequest.meterId = "";
      } else {
        this.pagerequest.meterId = item[0].id;
        this.pagerequest.areaId = 0;
      }
    }
    this.$store.commit("hoursuserecord/setCurrentPage", 1);
    this.getpage();
  }
  getSearch() {
    this.$store.commit("hoursuserecord/setCurrentPage", 1);
    this.getpage();
  }
  async getpage() {
    this.usebar.resize();
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    //console.log(this.pagerequest.skipCount);
    if (this.pagerequest.isTotal == 1) {
      this.columns = this.totalcolumns;
    } else {
      this.columns = this.detailcolumns;
    }
    this.loadsear = true;
    await this.$store
      .dispatch({
        type: "hoursuserecord/hoursListTotal",
        data: this.pagerequest,
      })
      .then((val) => {
        this.loadsear = false;
        this.usebar.clear();
        this.usebar.setOption(this.$data.baroption(val.barData));
        this.$store.state.hoursuserecord.totalCount = val.rowCount;
        this.$store.state.hoursuserecord.list = val.tableData;
        this.useCount = val.useTotalCount;
      })
      .catch((err) => {
        this.loadsear = false;
        this.$Modal.info({
          title: this.L("Tips"),
          content: err,
        });
      });
  }
  get pageSize() {
    return this.$store.state.hoursuserecord.pageSize;
  }
  get totalCount() {
    return this.$store.state.hoursuserecord.totalCount;
  }
  get currentPage() {
    return this.$store.state.hoursuserecord.currentPage;
  }
  //时间改变
  changdate(val) {
    if (val.length > 1) {
      this.pagerequest.startTime = Moment(val[0], "YYYY-MM-DD HH:mm:ss")
        .startOf("day")
        .format("YYYY-MM-DD HH:mm:ss");
      this.pagerequest.endTime = Moment(val[1], "YYYY-MM-DD HH:mm:ss")
        .endOf("day")
        .format("YYYY-MM-DD HH:mm:ss");
    }
  }
  //搜索树形结构
  searchTree(value: any, treeList) {
    if (!value) {
      this.areaTree = this.areaTreeList;
      return;
    }
    this.areaTree = [];
    this.areaTree = SearchTree.searnchTree(value, treeList);
  }
  //区域树形
  async getAreaTree() {
    await this.$store
      .dispatch("area/getAreaLeftTree")
      .then((val) => {
        this.areaTree = val;
        this.areaTreeList = val;
      })
      .catch((err) => {
        //return null;
      });
  }
  detailcolumns = [
    {
      type: "index",
      width: 80,
      align: "left",
      title: this.L("IndexNo"),
    },
    {
      title: this.L("Areas"),
      key: "areaName",
      sortable: true,
      width: 130,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.areaName,
            },
          },
          params.row.areaName
        );
      },
    },
    {
      title: this.L("Meter"),
      key: "meterNo",
      width: 130,
      sortable: true,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.meterNo,
            },
          },
          params.row.meterNo
        );
      },
    },
    {
      title: this.L("MeterCaliber"),
      key: "meterCaliber",
      width: 130,
    },
    {
      title: this.L("RoomNo"),
      key: "roomNo",
      width: 130,
      sortable: true,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.roomNo,
            },
          },
          params.row.roomNo
        );
      },
    },
    {
      title: this.L("Location"),
      key: "location",
      width: 150,
      sortable: true,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.location,
            },
          },
          params.row.location
        );
      },
    },
    {
      title: this.L("ReadTime"),
      key: "recordTime",
      width: 150,
      sortable: true,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.recordTime == null
            ? ""
            : new Date(params.row.recordTime).toLocaleString("zh", {
              hour12: false,
            })
        );
      },
    },

    {
      title: this.L("FirstReadNum"),
      key: "lastRead",
      width: 150,
      sortable: true,
    },
    {
      title: this.L("LastReadNum"),
      key: "thisRead",
      sortable: true,
      width: 150,
    },
    {
      title: this.L("ThisUse"),
      key: "thisUse",
      sortable: true,
      width: 150,
    },
    {
      title: this.L("Time"),
      key: "hoursName",
      sortable: true,
      width: 150,
    },
  ];
  totalcolumns = [
    {
      type: "index",
      width: 80,
      align: "left",
      title: this.L("IndexNo"),
    },
    {
      title: this.L("Areas"),
      key: "areaName",
      sortable: true,
      width: 130,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.areaName,
            },
          },
          params.row.areaName
        );
      },
    },
    {
      title: this.L("ReadTime"),
      key: "recordTime",
      width: 150,
      sortable: true,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.recordTime == null
            ? ""
            : new Date(params.row.recordTime).toLocaleString("zh", {
              hour12: false,
            })
        );
      },
    },
    {
      title: this.L("ThisUse"),
      key: "thisUse",
      width: 150,
      sortable: true,
    },
    {
      title: this.L("T0"),
      key: "t0",
      width: 150,
      sortable: true,
    },
    {
      title: this.L("T1"),
      key: "t1",
      width: 150,
      sortable: true,
    },
    {
      title: this.L("T2"),
      key: "t2",
      width: 150,
      sortable: true,
    },
    {
      title: this.L("T3"),
      key: "t3",
      width: 150,
      sortable: true,
    },
    {
      title: this.L("T4"),
      key: "t4",
      width: 150,
      sortable: true,
    },
    {
      title: this.L("T5"),
      key: "t5",
      width: 150,
      sortable: true,
    },
    {
      title: this.L("T6"),
      key: "t6",
      width: 150,
      sortable: true,
    },
    {
      title: this.L("T7"),
      key: "t7",
      width: 150,
      sortable: true,
    },
    {
      title: this.L("T8"),
      key: "t8",
      width: 150,
      sortable: true,
    },
    {
      title: this.L("T9"),
      key: "t9",
      width: 150,
      sortable: true,
    },
    {
      title: this.L("T10"),
      key: "t10",
      width: 150,
      sortable: true,
    },
    {
      title: this.L("T11"),
      key: "t11",
      width: 150,
      sortable: true,
    },
    {
      title: this.L("T12"),
      key: "t12",
      width: 150,
      sortable: true,
    },
    {
      title: this.L("T13"),
      key: "t13",
      width: 150,
      sortable: true,
    },
    {
      title: this.L("T14"),
      key: "t14",
      width: 150,
      sortable: true,
    },
    {
      title: this.L("T15"),
      key: "t15",
      width: 150,
      sortable: true,
    },
    {
      title: this.L("T16"),
      key: "t16",
      width: 150,
      sortable: true,
    },
    {
      title: this.L("T17"),
      key: "t17",
      width: 150,
      sortable: true,
    },
    {
      title: this.L("T18"),
      key: "t18",
      width: 150,
      sortable: true,
    },
    {
      title: this.L("T19"),
      key: "t19",
      width: 150,
      sortable: true,
    },
    {
      title: this.L("T20"),
      key: "t20",
      width: 150,
      sortable: true,
    },
    {
      title: this.L("T21"),
      key: "t21",
      width: 150,
      sortable: true,
    },
    {
      title: this.L("T22"),
      key: "t22",
      width: 150,
      sortable: true,
    },
    {
      title: this.L("T23"),
      key: "t23",
      width: 150,
      sortable: true,
    },
  ];
  async created() {
    this.pagerequest.startTime = Moment()
      .startOf("day")
      .format("YYYY-MM-DD HH:mm:ss");
    this.pagerequest.endTime = Moment()
      .endOf("day")
      .format("YYYY-MM-DD HH:mm:ss");
    this.pagerequest.isTotal = 0;
    this.getAreaTree();
    //this.getpage();
  }
  mounted() {
    if (window.innerHeight > 800) {
      (document.getElementById("echarts") as HTMLDivElement).style.height =
        "300px";
      this.height = window.innerHeight - 610;
    } else {
      (document.getElementById("echarts") as HTMLDivElement).style.height =
        "150px";
      this.height = window.innerHeight - 460;
    }

    this.usebar = echarts.init(
      document.getElementById("echarts") as HTMLDivElement
    );
    this.usebar.resize();
    //自动缩放
    window.addEventListener("resize", () => {
      this.usebar.resize();
    });
  }
  //汇总当前页数据
  handleSummary({ columns, data }) {
    const sums = {};
    columns.forEach((column, index) => {
      const key = column.key;
      if (index == 0) {
        sums[key] = {
          key,
          value: "合计",
        };
        return;
      }
      if (index == 1) {
        sums[key] = {
          key,
          value: this.L("ThisUse"),
        };
        return;
      }
      if (index == 2) {
        sums[key] = {
          key,
          value: this.useCount,
        };
        return;
      }
      if (index == 9 || index == 6 || index == 7) {
        sums[key] = {
          key,
          value: "",
        };
        return;
      }
      const values = data.map((item) => Number(item[key]));
      if (!values.every((value) => isNaN(value))) {
        const v = values.reduce((prev, curr) => {
          const value = Number(curr);
          if (!isNaN(value)) {
            return prev + curr;
          } else {
            return prev;
          }
        }, 0);
        sums[key] = {
          key,
          value: v.toFixed(2),
        };
      } else {
        sums[key] = {
          key,
          value: "",
        };
      }
    });
    return sums;
  }
  //导出数据
  async exportdata() {
    this.loadsear = true;
    this.pagerequest.operaType = 1;
    await this.$store
      .dispatch({
        type: "hoursuserecord/hoursListTotal",
        data: this.pagerequest,
      })
      .then((val) => {
        this.loadsear = false;
        if (this.pagerequest.isTotal == 1) {
          this.exportListTotal(val.tableData);
        } else {
          this.exportListDetail(val.tableData);
        }
      })
      .catch((err) => {
        this.loadsear = false;
        this.$Modal.info({
          title: this.L("Tips"),
          content: err,
        });
      });
  }
  //XLXS导出数据
  exportListTotal(list) {
    let title = [
      "区域",
      "读表时间",
      "总用量",
      "0点",
      "1点",
      "2点",
      "3点",
      "4点",
      "5点",
      "6点",
      "7点",
      "8点",
      "9点",
      "10点",
      "11点",
      "12点",
      "13点",
      "14点",
      "15点",
      "16点",
      "17点",
      "18点",
      "19点",
      "20点",
      "21点",
      "22点",
      "23点",
    ];
    let keylist = [
      "areaName",
      "readTime",
      "thisUse",
      "t0",
      "t1",
      "t2",
      "t3",
      "t4",
      "t5",
      "t6",
      "t7",
      "t8",
      "t9",
      "t10",
      "t11",
      "t12",
      "t13",
      "t14",
      "t15",
      "t16",
      "t17",
      "t18",
      "t19",
      "t20",
      "t21",
      "t22",
      "t23",
    ];
    let filename = Moment().format("YYYYMMDDHHmmss");
    const param = {
      title: title,
      key: keylist,
      data: list,
      autoWidth: true,
      filename: filename,
    };
    XLSX.export_array_to_excel(param);
  }
  //XLXS导出数据
  exportListDetail(list) {
    let title = [
      "区域",
      "安装位置",
      "表号",
      "户号",
      "读表时间",
      "期末数",
      "期初数",
      "用量",
      "时间",
    ];
    let keylist = [
      "areaName",
      "location",
      "meterNo",
      "roomNo",
      "readTime",
      "thisRead",
      "lastRead",
      "thisUse",
      "recordTime",
    ];
    let filename = Moment().format("YYYYMMDDHHmmss");
    const param = {
      title: title,
      key: keylist,
      data: list,
      autoWidth: true,
      filename: filename,
    };
    XLSX.export_array_to_excel(param);
  }
  data() {
    return {
      datepicker: {
        shortcuts: [
          {
            text: this.L("OneWeek"),
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
              return [start, end];
            },
          },
          {
            text: this.L("OneMonth"),
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 29);
              return [start, end];
            },
          },
          {
            text: this.L("ThreeMonths"),
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 89);
              return [start, end];
            },
          },
        ],
      },
      //柱形图参数
      baroption(bardto) {
        return {
          tooltip: {
            trigger: "axis",
            axisPointer: {
              // 坐标轴指示器，坐标轴触发有效
              type: "line", // 默认为直线，可选为：'line' | 'shadow'
            },
          },
          legend: {
            data: bardto.legend,
          },
          grid: {
            left: "3%",
            right: "4%",
            bottom: "3%",
            containLabel: true,
          },
          xAxis: [
            {
              type: "category",
              data: bardto.xAxis,
            },
          ],
          yAxis: [
            {
              type: "value",
            },
          ],
          series: bardto.series,
        };
      },
    };
  }
}
